/**
 * Binar javobni faylga aylantirish — BITTA joyda.
 *
 * Etiketka PDF i ham, buxgalteriya hujjatlari ham shu yo'ldan yuradi:
 * `apiBlob` bilan olingan `Blob` `objectURL` orqali saqlanadi. Bunday
 * qilinishining sababi imzolangan havolaga qarshi tanlovda: `<a href="/api/...">`
 * ochilsa, `Authorization` sarlavhasi ketmaydi va uni almashtirish uchun
 * tokenni manzilga yozishga to'g'ri kelardi — token esa brauzer tarixida,
 * jurnalda va yelkadan qaragan ko'zda qolib ketadi.
 */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // `revokeObjectURL` DARHOL chaqirilmaydi — ba'zi brauzerlarda yuklash
  // boshlanmasdan havola o'chib qolardi; keyingi kadrda tozalanadi.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

/**
 * Faylni KO'RSATISH — saqlash emas.
 *
 * `<a href="/api/v1/files/<id>">` ishlamaydi va bu nazariy emas: brauzer
 * yangi varaqqa `Authorization` sarlavhasini YUBORMAYDI, server esa
 * `{"code":"UNAUTHORIZED"}` qaytaradi. Odam esa ekranda akt o'rniga xato
 * matnini ko'radi. Shuning uchun baytlar avval klient bilan olinadi va
 * brauzerga o'zimiznikidan yasalgan `blob:` manzil beriladi.
 *
 * `noopener` ATAYLAB yo'q: u berilganda `window.open` har doim `null`
 * qaytaradi va "oyna bloklandi" tarmog'i ishga tushib, fayl ham ochilib,
 * ham yuklab olinardi. Manzil o'zimizniki va mazmuni faqat rasm/PDF
 * (`ALLOWED_UPLOAD_MIME_TYPES`), shuning uchun ochilgan varaqdan xavf yo'q.
 */
export const openBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);

  /* Ba'zi brauzerlar `blob:` ni yangi varaqda ochishni taqiqlaydi (yoki
     `window.open` umuman yo'q — mobil ilova ichidagi ko'rinish). Bunda
     jim qolmaymiz: fayl hech bo'lmasa saqlanadi. */
  let opened: Window | null = null;
  try {
    // `?? null` — amalga oshirilmagan muhitlarda (jsdom) `undefined` keladi.
    opened = window.open(url, '_blank') ?? null;
  } catch {
    opened = null;
  }

  if (opened === null) {
    URL.revokeObjectURL(url);
    downloadBlob(blob, fileName);
    return;
  }

  /* Manzil DARHOL bo'shatilmaydi: yangi varaq uni o'qib ulgurmasdi.
     Bir daqiqa — PDF ko'ruvchi yuklanishi uchun yetarli, xotira esa
     mangu band bo'lib qolmaydi. */
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
